import {
  type BusinessVaultFormData,
  businessVaultDataToHookForm,
  hookFormToBusinessVaultData,
} from '@onefootprint/core';
import type { ModernBusinessDecryptResponse, ModernRawBusinessDataRequest } from '@onefootprint/request-types';
import omitBy from 'lodash/omitBy';

export const fromVaultData = (vaultData?: ModernBusinessDecryptResponse) => {
  if (!vaultData) {
    return {};
  }
  return businessVaultDataToHookForm(vaultData);
};

export const toVaultData = (formData: BusinessVaultFormData) => {
  const rawVaultData = hookFormToBusinessVaultData(formData);

  // Remove empty or undefined values
  const cleanedVaultData = omitBy(rawVaultData, value => value === '' || value === undefined || value === null);

  return cleanedVaultData as ModernRawBusinessDataRequest;
};
